import { MENTION_BLOT_NAME, MentionValue } from "./mentionBlot";
import { MentionTrigger } from "./mentionTrigger";

/**
 * The slice of a Quill editor inserting a mention needs. Structural so the insert can be
 * exercised against a real editor in tests without dragging in React.
 */
export interface MentionEditor {
  deleteText(index: number, length: number, source: "user"): unknown;
  insertEmbed(
    index: number,
    type: string,
    value: MentionValue,
    source: "user"
  ): unknown;
  insertText(index: number, text: string, source: "user"): unknown;
  setSelection(index: number, length: number, source: "user"): unknown;
}

/**
 * Swaps the "@query" the user typed for a mention chip, leaving the caret on ordinary
 * text after it — a mention occupies exactly one document position, so the caret lands
 * two past where the chip started.
 */
export function insertMention(
  editor: MentionEditor,
  trigger: MentionTrigger,
  user: { id: number; commonName: string }
) {
  editor.deleteText(trigger.index, trigger.length, "user");
  editor.insertEmbed(
    trigger.index,
    MENTION_BLOT_NAME,
    { userId: user.id, name: user.commonName },
    "user"
  );
  editor.insertText(trigger.index + 1, " ", "user");
  editor.setSelection(trigger.index + 2, 0, "user");
}
